export enum PlayModes {
    Unknown,
    NoRules, 
    Genre,
    Artist,
    Similar,
    AiGenerated,
    Album,
    Track,
    Compilation,
    CompilationTrack,
    TrackPlaylist,
    AlbumPlaylist,
    Queue,
}